export enum EDashboardPageTitle {
  ORDERS = 'Orders',
  REPORTS = 'Reports',
  SUBSCRIPTIONS = 'Subscriptions'
}

export enum EManagementPageTitle {
  ANALYTICS = 'Analytics',
  PLAYERS = 'Players',
  SEGMENTS = 'Segments',
  PRICING = 'Pricing',
  COUPONS = 'Coupons',
  LOCALIZATION = 'Translations',
  SETTINGS = 'Settings'
}

export enum ESdkPageTitle {
  PACKAGE_EXPLORER = 'Package Explorer',
  TEST_AND_RELEASE = 'Test & Release'
}

export enum EStudioPageTitle {
  BUILDER = 'Builder',
  TEMPLATES_STUDIO = 'Template Studio',
  PRODUCTS = 'Products',
  OFFERS_DESIGN = 'Offers Design',
  OFFER_DESIGN_V2 = 'Offer Design V2',
  CHECKOUT_DESIGN = 'Checkout Design',
  BADGES = 'Badges',
  ASSETS_LIBRARY = 'Assets Library'
}

export enum EOffersPageTitle {
  BUNDLES = 'Bundles',
  PROMOTIONS = 'Promotions',
  POPUPS = 'Popups',
  TRIGGERED_POPUPS = 'Triggered Popups',
  DAILY_BONUS = 'Daily Bonus',
  ROLLING = 'Rolling',
  BUY_ONE_GET_MANY = '1+Many',
  CHECKOUT_LINKS = 'Checkout Links',
  PROGRESS_BAR = 'Progress Bar',
  PLANS = 'Plans',
  REWARD_CALENDAR = 'Reward Calendar'
}

export enum EPortalPageTitle {
  PAGES = 'Pages',
  CONTENT = 'Content',
  BUILDER = 'Builder'
}

export enum ESharedPageTitle {
  PROFILE = 'Profile'
}

export type PageTitle =
  | EDashboardPageTitle
  | EManagementPageTitle
  | ESdkPageTitle
  | EStudioPageTitle
  | EOffersPageTitle
  | EPortalPageTitle
  | ESharedPageTitle;

export enum EDashboardRoute {
  ORDERS = 'orders',
  REPORTS = 'reports/financialreports',
  SUBSCRIPTIONS = 'subscriptions'
}

export enum EManagementRoute {
  ANALYTICS = 'statistics',
  PLAYERS = 'players/blocked',
  SEGMENTS = 'segments',
  PRICING = 'pricing/points',
  COUPONS = 'coupons',
  LOCALIZATION = 'localization',
  SETTINGS = 'settings'
}

export enum ESdkRoute {
  PACKAGE_EXPLORER = 'package-explorer',
  TEST_AND_RELEASE = 'test-and-release'
}

export enum EStudioRoute {
  BUILDER = 'theme',
  TEMPLATES_STUDIO = 'templates-studio',
  PRODUCTS = 'products',
  OFFERS_DESIGN = 'offersui',
  CHECKOUT_DESIGN = 'checkoutdesigns',
  BADGES = 'badges',
  ASSETS_LIBRARY = 'assets'
}

export enum EOffersRoute {
  BUNDLES = 'bundles',
  PROMOTIONS = 'promotions',
  POPUPS = 'popups',
  DAILY_BONUS = 'daily-bonus',
  ROLLING = 'rolling',
  BUY_ONE_GET_MANY = 'buy-one-get-many',
  CHECKOUT_LINKS = 'checkoutlinks',
  PROGRESS_BAR = 'progressbars',
  PLANS = 'plans',
  REWARD_CALENDAR = 'reward-calendar'
}

export enum EPortalRoute {
  PAGES = 'pages',
  CONTENT = 'content',
  BUILDER = 'builder'
}
